export enum EConstraintType {
	cancel = "cancel",
	move = "move",
	intervenant = "intervenant",
	place = "place",
	reactivate = "reactivate",
	moveTo = "moveTo"
}